import { render, staticRenderFns } from "./Win2View.vue?vue&type=template&id=3a1396be&scoped=true"
var script = {}
import style0 from "./Win2View.vue?vue&type=style&index=0&id=3a1396be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1396be",
  null
  
)

export default component.exports